interface ErrorViewProps {
  error: Error;
  info: React.ErrorInfo;
}

export const ErrorView = ({ error, info }: ErrorViewProps) => {
  return (
    <div>
      <p>Inform users of an error in the component tree.</p>
      <b>error</b>
      <pre>{error.message}</pre>
      <b>info</b>
      <pre>{JSON.stringify(info)}</pre>
    </div>
  );
};
